import { render, staticRenderFns } from "./SendToRegionWithDialog.vue?vue&type=template&id=25e76ac1&scoped=true&"
import script from "./SendToRegionWithDialog.vue?vue&type=script&lang=js&"
export * from "./SendToRegionWithDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendToRegionWithDialog.vue?vue&type=style&index=0&id=25e76ac1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e76ac1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
